import { combineReducers } from 'redux';
import packageAddress from './package-address';
import packageTracking from './package-tracking';
import data from './private-package-tracker';
import screenFlow from './screen-flow';

const rootReducer = combineReducers({
  packageTracking,
  data,
  screenFlow,
  packageAddress
});

export default rootReducer;
